/**<params config data>说明
 * titleFontSize 标题文字大小 number
 * titleColor 标题文字颜色 string
 * desFontSize 描述文字大小 number
 * desColor 描述文字颜色 string
 * background 颜色：string
 * textAlign  文本框对齐 string  left center right
 * itemsColor  底部大文字颜色 string
 * itemsbomColor  底部小文字颜色 string
 * position 定位 string
 * data 数据 array
 */
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const configs = {
    bgColor: '#000',
    titleColor: '#fff',
    listBgColor: '#121212',
    listTitleColor: '#fff',
    listDesColor: '#478fff',
};
const items = [
    {
        bread: 'Interior / Exterior Design',
        title: 'Let’s get down to details.',
        des: 'DELTA Pro is designed inside and out for ease of use, durability and safety. Take a closer look. ',
        learnMoreLink: '/',
        learnMoreColor: '#03060B',
        attr: [
            {
                title: 'EcoFlow DELTA Portable Power Station',
                icon: '/img/delta11.png',
                des: 'Learn More',
                link: '/',
            },
            {
                title: 'EcoFlow DELTA Portable Power Station',
                icon: '/img/delta11.png',
                des: 'Learn More',
                link: '/',
            },
            {
                title: 'EcoFlow DELTA Portable Power Station',
                icon: '/img/delta11.png',
                des: 'Learn More',
                link: '/',
            },
        ],
    },
];
export default function productModule({ config, data = items }: any) {
    const { Link, useLang } = useGlobal();
    const { t } = useLang('shared');
    const configTypes = { ...configs, ...config };

    return (
        <div className={`${css.productModule} productModule`} style={{ background: configTypes.bgColor }}>
            <div className="container">
                <div className="title" style={{ color: configTypes.titleColor }}>
                    <span style={{ color: data[0].learnMoreColor || '#03060B' }}>
                        <Link href={data[0].learnMoreLink || '/'} ariaLabel={t('for_blind.view_more')}>
                            {t('site_details_product_view_more')}
                            {configTypes.bgColor == '#000' && (
                                <span className="imgs">
                                    <EFArrowDown style={{ fontSize: '10px', color: '#fff' }} />
                                </span>
                            )}
                            {configTypes.bgColor == '#fff' && (
                                <span className="imgs">
                                    <EFArrowDown style={{ fontSize: '10px', color: '#000' }} />
                                </span>
                            )}
                        </Link>
                    </span>
                    {t('site_details_product_others')}
                </div>
                <div className="list">
                    <ul>
                        {data[0].attr.slice(0, 2).map((item: any) => (
                            <li style={{ background: configTypes.listBgColor }}>
                                <span className="imgs">
                                    <Image src={item.icon} width={350} height={320} alt={item.title}></Image>
                                </span>
                                <div className="box">
                                    <h2 className="title font-family-extralight" style={{ color: configTypes.listTitleColor }}>
                                        {item.title}{' '}
                                    </h2>
                                    <Link href={item.link || '/'} ariaLabel={item.des}>
                                        <p className="des" style={{ color: configTypes.listDesColor }}>
                                            {item.des}
                                            <span className="imgs">
                                                <EFArrowRight style={{ color: configTypes.listDesColor }} />
                                            </span>
                                        </p>
                                    </Link>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
